// frontend/src/constants/layout.js
// Shared layout constants across the application

/**
 * Navigation drawer width in pixels
 * Used by AppShell and NotesWorkspace for consistent layout
 */
export const DRAWER_WIDTH = 280;

/**
 * Collapsed sidebar width for Notes workspace
 * Used when sidebar is minimized in Notes UI v2
 * Note: Currently set to 0 to fully hide sidebar when collapsed
 */
export const SIDEBAR_COLLAPSED_WIDTH = 0;

/**
 * App bar height in pixels
 * Standard Material-UI AppBar height
 */
export const APP_BAR_HEIGHT = 64;

/**
 * Mobile breakpoint (matches Material-UI theme)
 * Used for responsive behavior
 */
export const MOBILE_BREAKPOINT = 'md'; // 960px

/**
 * Z-index layers for consistent stacking
 */
export const Z_INDEX = {
  DRAWER: 1200,
  APP_BAR: 1100,
  COMMAND_BAR: 1300,
  EXPAND_BUTTON: 1250,
  MODAL: 1400,
  TOOLTIP: 1500,
};